/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import styles from './shared-styles';

const Close = ({ height, width, color, className, secondaryColor, ...props }) => (
  <span css={styles} className={className}>
    <svg viewBox="0 0 13 13" height={height} width={width} {...props} xmlns="http://www.w3.org/2000/svg">
      <g fill={color}>
        <path d="M7.58 6.5l5.2-5.19a.79.79 0 0 0 0-1.09.79.79 0 0 0-1.09 0L6.5 5.42 1.31.22a.79.79 0 0 0-1.09 0 .79.79 0 0 0 0 1.09l5.2 5.19-5.2 5.19a.79.79 0 0 0 0 1.09.77.77 0 0 0 .55.22.76.76 0 0 0 .54-.22l5.19-5.2 5.19 5.2a.79.79 0 0 0 1.09 0 .79.79 0 0 0 0-1.09z" />
      </g>
    </svg>
  </span>
);

Close.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string,
  secondaryColor: PropTypes.string
};

Close.defaultProps = {
  height: 25,
  width: 25,
  color: 'currentColor',
  className: '',
  secondaryColor: 'currentColor'
};

export default Close;
